import { render, staticRenderFns } from "./DetailTabs.vue?vue&type=template&id=21d8affd&scoped=true"
import script from "./DetailTabs.vue?vue&type=script&lang=ts"
export * from "./DetailTabs.vue?vue&type=script&lang=ts"
import style0 from "./DetailTabs.vue?vue&type=style&index=0&id=21d8affd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d8affd",
  null
  
)

export default component.exports